import { BaseApi } from "../shared/api";
import { startLoading, stopLoading } from "../shared/actions";
import { checkUnreadNotifications } from "../notifications/actions";
import * as types from "./actionTypes";
import * as url from "./apiUrls";

// Currently used to get userId from cookies
// used for Url building
// TODO: deprecate use of cookies outside base api
import Cookies from "universal-cookie";
const cookies = new Cookies();

const hydrateBusinessTrustPass = (payload) => ({
  type: types.BUSINESS_TRUSTPASS_HYDRATE,
  payload: payload
});

export function fetchBusinessTrustPass() {
  return (dispatch, getState) => {
  }
}

export function updateBusinessTrustPass(data, onSuccess) {
  return (dispatch, getState) => {
    dispatch(startLoading());
    dispatch(hydrateBusinessTrustPass(data.business_trustpass));

    const api = new BaseApi(dispatch, getState);
    const userId = cookies.get("userId");
    const { business_trustpass } = getState();

    return api.putRequest(
      url.businessTrustPass(userId, business_trustpass.id),
      data,
      response => {
        onSuccess(response);
        dispatch(stopLoading());
        dispatch(hydrateBusinessTrustPass(response));
      }
    )
  }
}

export function resolveNotifications(type, id) {
  return (dispatch, getState) => {
    const path = type === 'ptp' ? 'personal_trustpasses' : 'business_trustpasses';
    const { user } = getState();
    const api = new BaseApi(dispatch, getState);

    return api.putRequest(
      url.resolveNotifications(user.id, path, id),
      null,
      response => {
        dispatch({type: types.TRUSTPASS_RESOLVE_NOTIFICATIONS }) // does nothing but to log the event
        dispatch(checkUnreadNotifications());
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/trustpass/actions.js